import ArticleMeta from "./ArticleMeta";
import ArticleDek from "./ArticleDek";
import ArticleByline from "./ArticleByline";
import ArticleDateline from "./ArticleDateline";
import IdeasArticleByline from "./IdeasArticleByline";
import styles from "./ArticleHeader.module.scss";
import { ArticleHeaderFragment } from "types/api";
import gql from "graphql-tag";
import cx from "classnames";

const ArticleHeader = ({
  title,
  primaryCategory,
  ...props
}: ArticleHeaderFragment) => {
  const isIdeasArticle = props.primaryChannel?.slug === "ideas";
  return (
    <div className={cx(isIdeasArticle ? styles.ideasRoot : styles.root)}>
      {primaryCategory && (
        <div className={styles.rubric} id="rubric">
          {primaryCategory.url ? (
            <a
              className={styles.link}
              href={primaryCategory.url}
              data-action="click link - section rubric"
              data-label={primaryCategory.url}
            >
              {primaryCategory.displayName}
            </a>
          ) : (
            primaryCategory.displayName
          )}
        </div>
      )}
      <h1 className={styles.hed} dangerouslySetInnerHTML={{ __html: title }} />
      <ArticleMeta isIdeasArticle={isIdeasArticle}>
        <ArticleDek {...props} />
        {isIdeasArticle ? (
          <>
            <ArticleDateline {...props} />
            <IdeasArticleByline {...props} />
          </>
        ) : (
          <>
            <ArticleByline {...props} />
            <ArticleDateline {...props} />
          </>
        )}
      </ArticleMeta>
    </div>
  );
};

ArticleHeader.fragment = gql`
  ${ArticleDek.fragment}
  ${ArticleByline.fragment}
  ${ArticleDateline.fragment}
  ${IdeasArticleByline.fragment}

  fragment articleHeader on Article {
    __typename
    id
    title

    ...articleDek
    ...articleDateline

    ...ideasArticleByline
    ...articleByline

    primaryChannel {
      slug
    }
    primaryCategory {
      __typename
      ... on Category {
        displayName
        url
      }
      ... on Channel {
        displayName
        url
      }
      ... on EditorialProject {
        displayName
        url
      }
    }
  }
`;

export default ArticleHeader;
